export default function CategoryGraphDirective() {
  return {
    template: require('./category-graph.html'),
    scope: {
      category: '=',
    },
    controller: 'ECATCategoryGraphController',
    controllerAs: 'categoryGraphVM',
    bindToController: true,
    replace: true,
  };
}
